<template>
  <v-card flat class="pa-4">
    <!-- Snackbar -->
    <v-snackbar v-model="mensaje.snackbar" :timeout="mensaje.timeout" :color="mensaje.color" text top right>
      {{ mensaje.text }}
      <template v-slot:action="{ attrs }">
        <v-btn :color="mensaje.colorBtn" text v-bind="attrs" @click="mensaje.snackbar = false">Cerrar</v-btn>
      </template>
    </v-snackbar>

    <h3 class="mb-3">Administrar Roles</h3>
    <p class="caption grey--text mb-4">Crear, editar o eliminar roles del sistema.</p>

    <!-- Botón nuevo rol -->
    <v-row class="mb-3">
      <v-col>
        <v-btn color="grey darken-3" dark @click="openDialog(null)">
          <v-icon left>mdi-plus</v-icon> Nuevo Rol
        </v-btn>
      </v-col>
    </v-row>

    <!-- Tabla -->
    <v-simple-table fixed-header>
      <template v-slot:default>
        <thead>
          <tr>
            <th>ID</th>
            <th>Nombre</th>
            <th>Guard</th>
            <th>Creado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="role in roles" :key="role.id">
            <td>{{ role.id }}</td>
            <td>
              <v-chip small :color="roleColor(role.name)" dark>{{ role.name }}</v-chip>
            </td>
            <td>{{ role.guard_name }}</td>
            <td>{{ formatDate(role.created_at) }}</td>
            <td>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <!-- Dialog crear/editar -->
    <v-dialog v-model="dialog" max-width="400" persistent>
      <v-card>
        <v-card-title>{{ editando ? 'Editar' : 'Nuevo' }} Rol</v-card-title>
        <v-card-text>
          <v-form ref="formRole" v-model="valid">
            <v-text-field v-model="roleForm.name" label="Nombre del rol"
              :rules="[v => !!v || 'Requerido']" outlined dense></v-text-field>
            <v-text-field value="web" label="Guard" outlined dense disabled></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="grey darken-3" dark :loading="saving" @click="guardar">
            {{ editando ? 'Actualizar' : 'Crear' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import adminService from '@/services/adminService.js';

export default {
  name: 'RolesCrudAdmin',
  data() {
    return {
      roles: [],
      dialog: false,
      editando: false,
      valid: true,
      saving: false,
      roleForm: { id: null, name: '' },
      mensaje: {
        snackbar: false,
        text: '',
        color: '',
        colorBtn: '',
        timeout: 4000
      }
    };
  },
  mounted() {
    this.cargarRoles();
  },
  methods: {
    cargarRoles() {
      adminService.listRoles().then(res => {
        this.roles = res.data;
      });
    },
    openDialog(role) {
      if (role) {
        this.editando = true;
        this.roleForm = { id: role.id, name: role.name };
      } else {
        this.editando = false;
        this.roleForm = { id: null, name: '' };
      }
      this.dialog = true;
    },
    guardar() {
      if (!this.$refs.formRole.validate()) return;
      this.saving = true;

      const action = this.editando
        ? adminService.updateRole(this.roleForm.id, { name: this.roleForm.name })
        : adminService.createRole({ name: this.roleForm.name });

      action.then(() => {
        this.showMsg(this.editando ? 'Rol actualizado' : 'Rol creado', 'success');
        this.dialog = false;
        this.cargarRoles();
      }).catch(err => {
        const errors = err.response && err.response.data && err.response.data.errors;
        this.showMsg(errors ? errors.join(', ') : 'Error al guardar', 'error');
      }).finally(() => {
        this.saving = false;
      });
    },
    eliminar(role) {
      if (!confirm('¿Eliminar el rol "' + role.name + '"? Los usuarios con este rol lo perderán.')) return;
      adminService.deleteRole(role.id).then(() => {
        this.showMsg('Rol eliminado', 'success');
        this.cargarRoles();
      }).catch(() => {
        this.showMsg('Error al eliminar', 'error');
      });
    },
    roleColor(name) {
      const colors = { admin: 'red darken-2', seller: 'orange darken-1', user: 'blue darken-1' };
      return colors[name] || 'grey darken-2';
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      return d.toLocaleDateString('es', { day: '2-digit', month: 'short', year: 'numeric' });
    },
    showMsg(text, type) {
      this.mensaje.text = text;
      this.mensaje.color = type === 'success' ? 'success' : 'error';
      this.mensaje.colorBtn = type === 'success' ? 'green darken-1' : 'red darken-1';
      this.mensaje.snackbar = true;
    }
  }
};
</script>
